import { Flame, Clock, ChevronRight } from "lucide-react";

export function DealBanner({ deal, countdown, onClaim }) {
    if (!deal) return null;
    return (
        <button onClick={onClaim} data-testid="deal-banner-claim"
            className="group sticky top-16 z-40 w-full text-left bg-gradient-to-r from-volt/[0.14] via-obsidian to-obsidian border-b border-volt/30 hover:border-volt/60 transition-colors">
            <div className="max-w-7xl mx-auto px-5 md:px-10 py-2.5 flex items-center justify-center gap-2 sm:gap-4 text-center flex-wrap">
                <span className="flex items-center gap-1.5 text-volt font-mono text-[11px] uppercase tracking-[0.15em]">
                    <Flame className="w-3.5 h-3.5" /> Daily Deal
                </span>
                <span className="text-white text-xs sm:text-sm font-semibold">
                    {deal.label}: <span className="text-volt">{deal.desc}</span>
                </span>
                <span className="flex items-center gap-1.5 font-mono text-xs text-white/70" data-testid="deal-countdown">
                    <Clock className="w-3.5 h-3.5 text-volt" /> {countdown}
                </span>
                <span className="hidden sm:flex items-center gap-1 text-xs font-bold uppercase text-volt group-hover:gap-2 transition-all">
                    Claim Code <ChevronRight className="w-3.5 h-3.5" />
                </span>
            </div>
        </button>
    );
}
